import DashboardMainView from './DashboardMain';

export default DashboardMainView;
